document.addEventListener('DOMContentLoaded', () => {

  const nav = document.querySelector('.t_n')

  const path = window.location.pathname
    .replace(/\/$/, '')
    .toLowerCase()

  const pathParts = path.split('/').filter(Boolean)

  const isHome =
    path === '' ||
    pathParts.length === 1

  const updateTransparentState = () => {

    /* TODO: MC - Quitar este codigo comentado si no hay contador */
    /*if (!isHome) return

    const isScrolled = window.scrollY > 10

    const hasDesktopMega =
      nav.querySelector('.t_n__mega.is-active')

    const mobileOpen =
      mobileDrawer?.classList.contains('is-active')

    if (
      isScrolled ||
      hasDesktopMega ||
      mobileOpen ||
      navHovered
    ) {

      nav.classList.remove('is-transparent')
      nav.classList.add('is-solid')

    } else {

      nav.classList.add('is-transparent')
      nav.classList.remove('is-solid')

    }*/

  }

  if (!nav) return

  if (isHome) {
    /* TODO: MC - Quitar este codigo comentado si no hay contador */
    //nav.classList.add('is-transparent')
  }

  // ✅ MEJORA 4: reducidos a los selectores reales del tema
  const SEARCH_CANDIDATES = [
  '.search-drawer-button[aria-controls="SearchDrawer"]',
  ]

  const CART_CANDIDATES = [
    '.cart-drawer-button[aria-controls="CartDrawer"]',
  ]
  const SEARCH_ELEMENTS = SEARCH_CANDIDATES
    .map(selector => {
      try { return document.querySelector(selector) }
      catch { return null }
    })
    .filter(Boolean)

  const CART_ELEMENTS = CART_CANDIDATES
    .map(selector => {
      try { return document.querySelector(selector) }
      catch { return null }
    })
    .filter(Boolean)

  const tryOpen = (elements) => {
    for (const el of elements) {
      el.dispatchEvent(new Event('click', { bubbles: true }))
      return true
    }
    return false
  }

const openSearch = (e) => {
  e.preventDefault()
  const drawer = document.getElementById('SearchDrawer')
  if (drawer) {
    drawer.show(e.target)
  } else {
    window.location.href = '/search'
  }
}

const openCart = (e) => {
  e.preventDefault()
  const drawer = document.getElementById('CartDrawer')
  if (drawer) {
    drawer.show(e.target)
  } else {
    window.location.href = '/cart'
  }
}

  nav.addEventListener('click', (e) => {
    const searchTrigger = e.target.closest('[data-t_n-open="search"]')
    const cartTrigger = e.target.closest('[data-t_n-open="cart"]')
    if (searchTrigger) { openSearch(e); return }
    if (cartTrigger) { openCart(e); return }
  })

  const desktop = nav.querySelector('.t_n__desktop')
  const desktopHeader = nav.querySelector('.t_n__header')
  const desktopTriggers = [...nav.querySelectorAll('[data-nav-trigger]')]
  const desktopPanels = [...nav.querySelectorAll('[data-nav-panel]')]
  const mobileToggle = nav.querySelector('[data-mobile-toggle]')
  const mobileDrawer = nav.querySelector('.t_n__mobile_drawer')
  const mobilePanels = [...nav.querySelectorAll('[data-mobile-panel]')]

  let activeMobilePanel = 'root'
  let activeDesktop = null
  let desktopTimeout = null
  let navHovered = false

  const closeDesktop = () => {
    for (const panel of desktopPanels) panel.classList.remove('is-active')
    for (const trigger of desktopTriggers) trigger.classList.remove('is-active')
    activeDesktop = null
    updateTransparentState()
  }

  const setActiveDesktop = (target) => {
    if (activeDesktop === target) return
    activeDesktop = target
    updateTransparentState()
    for (const trigger of desktopTriggers) {
      trigger.classList.toggle('is-active', trigger.dataset.target === target)
    }
    for (const panel of desktopPanels) {
      panel.classList.toggle('is-active', panel.dataset.navPanel === target)
    }
  }

  if (desktop) {
    desktop.addEventListener('mouseover', (e) => {
      const trigger = e.target.closest('[data-nav-trigger]')
      if (!trigger) return
      clearTimeout(desktopTimeout)
      setActiveDesktop(trigger.dataset.target)
    })
    desktop.addEventListener('mouseleave', () => {
      desktopTimeout = setTimeout(() => { closeDesktop() }, 120)
    })
  }

  if (desktopHeader) {
    desktopHeader.addEventListener('mouseenter', () => {
      navHovered = true
      updateTransparentState()
    })
    desktopHeader.addEventListener('mouseleave', () => {
      navHovered = false
      updateTransparentState()
    })
  }

  const setMobilePanel = (target) => {
    activeMobilePanel = target
    for (const panel of mobilePanels) {
      const panelId = panel.dataset.mobilePanel
      panel.classList.remove('is-active', 'is-prev')
      if (panelId === target) panel.classList.add('is-active')
      else if (panelId === 'root') panel.classList.add('is-prev')
    }
  }

  if (mobileToggle && mobileDrawer) {

    mobileToggle.addEventListener('click', () => {

      const isOpen = mobileDrawer.classList.contains('is-active')

      // ✅ MEJORA 1: todas las mutaciones DOM agrupadas en rAF
      requestAnimationFrame(() => {

        if (isOpen) setMobilePanel('root')

        mobileDrawer.classList.toggle('is-active')
        mobileToggle.classList.toggle('is-active')
        mobileToggle.setAttribute('aria-expanded', String(!isOpen))
        mobileDrawer.setAttribute('aria-hidden', String(isOpen))
        document.documentElement.classList.toggle('t_n__lock', !isOpen)
        document.body.classList.toggle('t_n__lock', !isOpen)

        updateTransparentState()

      })

    })

  }

  nav.addEventListener('click', (e) => {
    const nextButton = e.target.closest('[data-mobile-next]')
    const backButton = e.target.closest('[data-mobile-back]')
    if (nextButton) setMobilePanel(nextButton.dataset.mobileNext)
    if (backButton) setMobilePanel('root')
  })

  const topbarTrack = nav.querySelector('.t_n__topbar_track')

  if (topbarTrack) {

    const topbarItems = [...topbarTrack.querySelectorAll('.t_n__topbar_item')]

    if (topbarItems.length > 1) {

      let activeIndex = 0
      let topbarInterval = null

      const updateTopbar = () => {
        topbarTrack.style.transform = `translateX(-${activeIndex * 100}%)`
      }

      const startTopbar = () => {
        topbarInterval = setInterval(() => {
          activeIndex++
          if (activeIndex >= topbarItems.length) activeIndex = 0
          updateTopbar()
        }, 4000)
      }

      // ✅ MEJORA 3: pausar el interval cuando la pestaña está en segundo plano
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearInterval(topbarInterval)
        } else {
          startTopbar()
        }
      })

      window.addEventListener('beforeunload', () => clearInterval(topbarInterval))

      startTopbar()

    }

  }

  // ✅ MEJORA 2: updateCartCount solo si el dato no está ya en el HTML,
  //    y evitando el fetch innecesario en pageshow si no hubo cambios
  let cartCountKnown = false

  const updateCartCount = async () => {
    try {
      const response = await fetch('/cart.js')
      const cart = await response.json()
      const counts = [...document.querySelectorAll('[data-cart-count]')]
      for (const count of counts) {
        count.textContent = cart.item_count
        count.classList.toggle('is-hidden', cart.item_count < 1)
      }
      cartCountKnown = true
    } catch (error) {
      console.warn(error)
    }
  }

  document.addEventListener('cart:refresh', updateCartCount)
  document.addEventListener('cart:updated', updateCartCount)
  document.addEventListener('ajaxProduct:added', updateCartCount)

  // Solo hace fetch en pageshow si no tenemos el dato ya
  window.addEventListener('pageshow', () => {
    if (!cartCountKnown) updateCartCount()
  })

  window.addEventListener('scroll', updateTransparentState, { passive: true })

  updateTransparentState()
  updateCartCount()

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    if (mobileDrawer && mobileToggle) {
      mobileDrawer.classList.remove('is-active')
      mobileToggle.classList.remove('is-active')
      mobileToggle.setAttribute('aria-expanded', 'false')
      mobileDrawer.setAttribute('aria-hidden', 'true')
    }
    document.documentElement.classList.remove('t_n__lock')
    document.body.classList.remove('t_n__lock')
    setMobilePanel('root')
    closeDesktop()
  })

  const verticalCatalogButton = document.querySelector('[data-vertical-menu-catalog]')
  if (verticalCatalogButton) {
    verticalCatalogButton.addEventListener('click', () => {
      const mobileToggle = document.querySelector('[data-mobile-toggle]')
      if (mobileToggle) mobileToggle.click()
    })
  }

  const verticalSearchTrigger = document.querySelector('#vertical-floating-menu [data-t_n-open="search"]')
  if (verticalSearchTrigger) {
    verticalSearchTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      const realSearchButton = document.querySelector(
        '.t_n__desktop .t_n__icon--search, .t_n__mobile .t_n__icon--search'
      )
      if (realSearchButton) realSearchButton.click()
    })
  }

  const verticalCartTrigger = document.querySelector('#vertical-floating-menu [data-t_n-open="cart"]')
  if (verticalCartTrigger) {
    verticalCartTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      const realCartButton = document.querySelector(
        '.t_n__desktop .t_n__icon--cart, .t_n__mobile .t_n__icon--cart'
      )
      if (realCartButton) realCartButton.click()
    })
  }

})
